import React from "react";

const GlossaryDetails = () => {
  return <div>GlossaryDetails</div>;
};

export default GlossaryDetails;
